var Spinner = require("components/utility/Spinner");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var DropDownOptions = require("components/utility/DropDownOptions");
var Localization = require("lib/interface/Localization");
var ReactTooltip = require("react-tooltip");
var Glyphicon = require("components/utility/icons/Glyphicon");

require("payments/credit_card_input.scss");

class CreditCardInput extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			stripeToken: null, wepayToken: null,
			loadedDependencies: false, loading: false
		};
	}

	useStripe() {
		return this.props.paymentInfo.stripe_public_key != undefined;
	}

	useWepay() {
		return this.props.paymentInfo.wepay_account_id != undefined;
	}

	// userData: A hash containing "name" and "email"
	// callback: An optional function that takes two arguments:
	//    true/false depending on charge success and a hash containing payment platforms
	tokenize(userData, callback) {
		if (!this.state.loading) {
			this.setState({ loading: true });
			this.refs.errors.reset();
			var $wrap = $(this.refs.creditCardInput);

			if (userData) {
				$(this.refs.nameInput).val(userData.name);
				$(this.refs.emailInput).val(userData.email);
			}

			if (this.useStripe()) {
				Stripe.setPublishableKey(this.props.paymentInfo.stripe_public_key);

				Stripe.card.createToken($wrap, (status, response) => {
					if (response.error) {
						this.refs.errors.setError(response.error.message);
						
						this.setState({ loading: false });
						if (callback) {
							callback(false);
						}

						// $wr.scrollToElement($wrap[0])

					} else {
						var token = response.id;
						if (callback) {
							callback(true, { stripe_token: token });
						}
					}
				});

			} else if (this.useWepay()) {

				// THIS HASN'T BEEN USED IN WR CREDIT CARD INPUT

				var wepayClientID = $('meta[name="wepay-client-id"]').attr("content");
				
				var cardData = {
					client_id: 			wepayClientID,

					cc_number: 			this.refs.number.value,
					cvv: 				this.refs.cvc.value,
					expiration_month:	this.refs.expMonth.value,
					expiration_year:	this.refs.expYear.value,

					user_name: 			this.refs.nameInput.value,
					email:				this.refs.emailInput.value,
					address: 			{ zip: this.refs.billingZIP.value.trim() }
				}

				var initialResponse = WePay.credit_card.create(cardData, (data) => {
					if (data.error) {
						this.handleWepayError(data.error_description)
						if (callback) {
							callback(false);
						}

					} else {
						var token = data.credit_card_id;
						this.setState({ wepayToken: token }, () => {
							if (callback) {
								callback(true, { wepay_token: token });
							}
						});
					}
				});
				if (initialResponse.error) {
					$wrap.trigger("credit-card-error");
					this.handleWepayError(initialResponse.error_description)
				}

			} else {
				throw "No payment credentials loaded!";
			}
		}
	}

	handleWepayError(rawError) {
		var errorText;
		switch(rawError.trim()) {
			case "The cc_number parameter is required.":
				errorText = "Please enter a credit card number."; break;
			case "The cvv parameter is required.":
				errorText = "Please enter a CVC"; break;
			case "ZIP Code '' is invalid":
				errorText = "Please enter a ZIP code"; break;
			default:
				errorText = rawError; break;
		}

		this.refs.errors.setError(errorText);
		this.setState({ loading: false });
	}

	render() {
		if (!this.state.loadedDependencies) {
			return (
				<div className="creditCardInput">
					<Spinner placeholder={ true } />
				</div>
			);
		}

		var translations = Localization.getTranslations("credit_card");

		return (
			<div className="creditCardInput" ref="creditCardInput">
				<ErrorDisplay ref="errors" />

				<input type="hidden" data-stripe="name" ref="nameInput" />
				<input type="hidden" data-stripe="email" ref="emailInput" />

				<div className="creditCardInfoLine">
					<img src={ require("logos/visa.png") } alt="visaLogo" className="ccLogo" />
					<img src={ require("logos/mastercard.png") } alt="visaLogo" className="ccLogo" />
					<img src={ require("logos/american-express.png") } alt="visaLogo" className="ccLogo" />
					<img src={ require("logos/discover.png") } alt="visaLogo" className="ccLogo" />
					<img src={ require("logos/jcb.png") } alt="visaLogo" className="ccLogo" />
				</div>

				<div className="creditCardInfoLine">
					<label className="numberField">
						<span>{ translations.number }</span>
						<div className="securityNote">
							<Glyphicon icon="lock" /> SECURE
						</div>
						<input type="text" data-stripe="number" ref="number"
							className="form-control number" placeholder="1111 2222 3333 4444" />
					</label>
				</div>

				<div className="creditCardInfoLine">
					<label className="expMonthField">
						<span>{ translations.expiration }</span>
						<select type="text" className="form-control month" ref="expMonth"
							data-stripe="exp-month" id="expMonth">
							{ DropDownOptions.Select.Months({ longForm: true }) }
						</select>
					</label>

					<label className="expYearField">
						<span></span>
						<select type="text" className="form-control year" ref="expYear"
							data-stripe="exp-year">
							{ DropDownOptions.Select.FutureYears({ yearsForward: 25, shortFrom: true }) }
						</select>
					</label>
				</div>

				<div className="creditCardInfoLine">
					<label className="cvcField">
						{ translations.security_code } <Glyphicon icon="question-sign" dataTip={ translations.cvc_tooltip } />
						<input type="text" className="form-control cvc" data-stripe="cvc" ref="cvc" />
					</label>

					<label className="billingZipField">
						<span>{ translations.zip_code }</span>
						<input type="text" className="form-control billing-zip" ref="billingZIP"
							data-stripe="address_zip" />
					</label>
				</div>
			</div>
		);
	}

	componentDidMount() {
		$wr.loadScript("https://js.stripe.com/v1", "Stripe", () => {
			this.setState({ loadedDependencies: true });
		});
	}
};

if ($wr.isProduction()) {
	CreditCardInput.STRIPE_PUBLIC_KEY = "pk_live_WPpwqypzAMeHf2FAepHwoAdE"
} else if ($wr.isStaging()) {
	CreditCardInput.STRIPE_PUBLIC_KEY = "pk_test_ImABw5k0qlia4jLZaY5N3Aa2"
} else {
	CreditCardInput.STRIPE_PUBLIC_KEY = "pk_test_eeAms8duPFufyoRikibYt4Vl"
}

CreditCardInput.propTypes = StrictPropTypes({
	// Contains WePay or Stripe Info
	paymentInfo: PropTypes.object.isRequired,

	// (optional) Extra info for credit card: name, email
	extraInfo: PropTypes.object
});

module.exports = CreditCardInput;



// WEBPACK FOOTER //
// ./modules/components/payments/CreditCardInput.js